import type from "./type";

export default type("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-request/src/json.js
// module id = ../../../../d3-request/src/json.js
// module chunks = 4